export function openLink(url, target) {
	const elem = document.createElement('a')
	elem.href = url
	if (target) elem.target = target
	elem.style.display = 'none'
	document.body.appendChild(elem)
	elem.click()
}